import { render, staticRenderFns } from "./ItemTunings.vue?vue&type=template&id=d067e1f6&scoped=true&"
import script from "./ItemTunings.vue?vue&type=script&lang=js&"
export * from "./ItemTunings.vue?vue&type=script&lang=js&"
import style0 from "./ItemTunings.vue?vue&type=style&index=0&id=d067e1f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d067e1f6",
  null
  
)

export default component.exports